import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {User} from "../../../user/user";
import {Config} from "../../../config/config";
import {clientRoles} from "../../../user/user-roles-actions";
import {Workspace} from "../../../user-managment/workspace";
import {Website} from "../../website/website";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../user/user-subscription";
import {RechargeComponent} from "../../../shared/components/dialogs/recharge-dialog/recharge.component";
import {
  NotificationDialogComponent
} from "../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../shared/utils/text-utils";
import {PaymentDialogComponent} from "../../../workspace/billing/payment-dialog/payment-dialog.component";
import {DbModalService} from "../../../modules/modal/modal";
import {Router} from "@angular/router";
import {CookieService} from "ngx-cookie";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {CreateWebsiteService} from "../../../services/local/create-website.service";
import {RemoveWebsiteComponent} from "../../remove-website/remove-website.component";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {WebsiteService} from "../../website.service";
import {RemoveDemoComponent} from "../../../shared/components/dialogs/remove-demo/remove-demo.component";
import {combineLatest, Subject} from "rxjs";
import {ActivityStatus} from "../../../activities/activity";
import {Utils} from "../../../shared/utils/utils";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {OneMonthFreeComponent} from "../../../shared/components/dialogs/one-month-free/one-month-free.component";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'db-website-item-actions',
    templateUrl: './website-item-actions.component.html',
    styleUrls: ['./website-item-actions.component.scss'],
    standalone: false
})
export class WebsiteItemActionsComponent implements OnInit {

  @Input() website!: Website;
  @Input() user: User;
  @Input() userSubscription: UserSubscription;
  @Input() currentWorkspace: Workspace;
  @Input() hostedWebsiteLimit: number;
  @Input() hostedWebsitesIncludedMultiCount: number;
  @Input() disableCopyWebsite: boolean;
  @Output() onGAEvent: EventEmitter<{ label: string, action?: string }> = new EventEmitter<{
    label: string,
    action?: string
  }>();
  @Output() openDemoIframe: EventEmitter<string> = new EventEmitter<string>();

  public dbTesting: boolean = false;
  public childWebsiteId: number;
  public canClone: boolean = false;
  public demoUser: boolean = false;
  public disableControls: boolean = false;
  public previewUrl: string;
  public readonly clientRoles = clientRoles;
  public readonly defaultStarterPlanId = Config.defaultStarterPlanId;
  public readonly basePlanId = Config.basePlanId;
  needRedirectToRegenerate = false;
  redirectUrl: string;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  private _destroyRef = inject(DestroyRef);

  constructor(
    private _dialogService: DialogService,
    private _dbModal: DbModalService,
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private _cookieService: CookieService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _modalService: DbModalService,
    private _createWebsiteService: CreateWebsiteService,
    private _websiteService: WebsiteService
  ) {
  }

  ngOnInit() {
    this._initData();
    if (this.website?.isWVC) {
      this._listenVibeFiles();
      this._store.dispatch(new fromStore.LoadVibeFiles({domainId: this.website.id}));
    }
  }

  private _listenVibeFiles() {
    this._store.select(fromStore.getVibeFilesStatus(this.website.id))
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe(value => {
          this.needRedirectToRegenerate = value === 'fail';
        });
  }

  private _initData(): void {
    /*TODO get demoUser from parent component */
    this.demoUser = Utils.isDemoUser(this.userSubscription, this.user);
    this.dbTesting = !!this._cookieService.get('db-testing');
    this.previewUrl = this.demoUser ? `${this.website.site_url}?from=websites&client_id=${this.user.id}&domain_id=${Config.demoDomainId}&first_time` + (this.dbTesting ? `&db-testing` : ``) : this.website.site_url;
    if (this.website && this.userSubscription) {
      const redirectPath = this.website?.isWVC ? 'admin.php?page=wvc-editor' : '?edit.php?post_type=page&from=tenweb_dashboard&open=homepage';
      this.redirectUrl = this.website?.adminUrl + redirectPath;
    }
    this.childWebsiteId =
      this.website.isNetwork && this.website.children
      && this.website.children.length ? this.website.children[0] : null;
    this.canClone = this.website && this.user && this.website.domain_hash && !this.disableCopyWebsite && !this.website.isNetwork
      && !this.user.oneProductOrBundleClient && this.userSubscription && !this.userSubscription.isExpired
      && (
        (!this.userSubscription.trialClient
          && !this.userSubscription.trialOptimizerClient && !this.userSubscription.freeBaseClient)
      );
    this._getWebsite();
    this._ongoingActivities();
  }

  private _ongoingActivities(): void {
    this._store.select(fromStore.getOngoingActivities)
      .pipe(
        filter((loaded: any) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getMigrationOngoingActivity),
          this._store.select(fromStore.getCreateWebsiteOngoingActivity),
          this._store.select(fromStore.getAddWebsiteOngoingActivity)
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([migrationActivity, createActivity, addWebsiteActivity]) => {
        if (!migrationActivity && !createActivity && !addWebsiteActivity) {
          return;
        }

        const ongoingActivity = migrationActivity ? migrationActivity : (createActivity ? createActivity : addWebsiteActivity);
        switch (ongoingActivity.status) {
          case ActivityStatus.DONE:
          case ActivityStatus.FAILED:
            this.disableControls = false;
            break;
          case ActivityStatus.RUNNING:
            this.disableControls = true;
            break;
          default:
            this.disableControls = true;
            break;
        }
      });
  }

  redirectToRegenerate() {
    this._router.navigate([`/websites/${this.website.id}/main`], {queryParams: {regenerate: true}});
  }

  private _getWebsite(): void {
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean) => !!loaded),
        switchMap(() => this._store.select(fromStore.getWebsite(this.website.id))),
        first()
      )
      .subscribe((website: Website): void => {
        this.website = website;
        this.previewUrl = this.demoUser ? `${this.website.site_url}?from=websites&client_id=${this.user.id}&domain_id=${Config.demoDomainId}&first_time` + (this.dbTesting ? `&db-testing` : ``) : this.website.site_url;
      });
  }


  public removeWebsite(): void {
    if (this.website && !!this.website.isAiBuilderDemo) {
      this._removeDemoWebsite();
    } else {
      const modal = this._modalService.open(RemoveWebsiteComponent);
      modal.componentInstance.website = this.website;
    }
  }

  private _removeDemoWebsite(): void {
    this._modalService.open(RemoveDemoComponent, {height: 233, width: 500});
  }

  public cloneWebsite() {
    if (this.userSubscription
      && [UserSubscriptionType.PREMIUM, UserSubscriptionType.ONE_PRODUCT].includes(this.userSubscription.type)
      && this.userSubscription.plan && this.userSubscription.plan.services
      && this.userSubscription.plan.services.hosting.domain_count
      && this.hostedWebsitesIncludedMultiCount >= (
        parseInt(this.userSubscription.plan.services.hosting.domain_count.parameter_value, 10) + this.userSubscription.plan.additionalDomainCount)
    ) {
      return this.showExceededDialog();
    } else {
      this._showCloneWebsiteDialog();
    }
  }

  private showExceededDialog() {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId && this.demoUser) {
      return this.showCheckoutDialog('creation');
    }
    if (this.currentWorkspace && this.currentWorkspace.roleId
      && ![clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(this.currentWorkspace.roleId)
      && this.userSubscription && this.userSubscription.recharge) {
      const modal = this._modalService.open(RechargeComponent, {height: 208, width: 700});
      modal.componentInstance.userSubscription = this.userSubscription;
      return;
    }
    let exceededDesc = "text_domainsExceededUpgradeToHigher";
    let exceededBtnText = "text_upgrade";
    let exceededBtnColor = "green";
    let action = "upgrade";
    if (this.currentWorkspace && this.currentWorkspace.roleId === clientRoles.COMPANY_DEV) {
      action = "got it";
      exceededDesc = "text_domainsExceededContactOwner";
      exceededBtnText = "text_emailVerification.gotIt";
      exceededBtnColor = "blue";
    }
      switch (this.userSubscription.category) {
        case UserSubscriptionCategory.STARTER:
          exceededDesc = 'text_domainsExceededUpgradeToPaid';
          break;
        case UserSubscriptionCategory.PERSONAL:
        case UserSubscriptionCategory.PREMIUM:
          exceededDesc = 'text_domainsExceededUpgradeToHigher';
          break;
        case UserSubscriptionCategory.ENTERPRISE:
          exceededDesc = 'text_domainsExceededBuyAdditional';
          exceededBtnText = "text_buyNow";
          exceededBtnColor = 'blue';
          action = 'buyNow';
          break;
    }
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_domainsExceededTitleDialog'),
      message: TextUtils.getText(exceededDesc),
      buttonText: TextUtils.getText(exceededBtnText),
      buttonColor: exceededBtnColor,
      action: action,
      hasCloseButton: true
    })
      .subscribe((confirmed: string): void => {
        if (confirmed) {
          if (confirmed === 'upgrade') {
            this._router.navigate(['/upgrade-plan']);
          } else if (confirmed === 'buyNow') {
            this._dialogService
              .addDialog(PaymentDialogComponent, {
                upgradeSubscription: this.userSubscription,
                fromDialog: true,
                showAdditional: true
              });
          }
        }
      });
  }

  private _showCloneWebsiteDialog(): void {
    this._createWebsiteService.openCloneWebsiteModal(this.website);
  }

  public showCheckoutDialog(from: 'feature' | 'creation' | 'wp-admin' | 'editor'): void {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: "Locked button click",
      eventLabel: from === 'feature' || from === 'wp-admin' ? "WP Admin" : "Edit Website"
    };

    if (this.demoUser) {
      const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
      const options = {
        overflowHidden: false,
        backdropClass: 'blurred',
      };
      if (!firstTime) {
        options['width'] = 1240;
      } else {
        options['width'] = 460;
        options['height'] = 600;
      }
      const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
      modal.componentInstance.showFirstTime = firstTime;
    } else {
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = from;
      /* modal.componentInstance.mixed = from === 'editor' && this.demoUser;*/
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


}
